// Shared sticker definitions used by the pitching grid + talent view.
// 'pp' can be auto-derived from confirmed deals OR toggled manually (pre-existing partners).
// 'engaged' auto-derives from Brand.last_meeting_date within the last 3 months.
export const STICKERS = [
  { id: 'pp',      emoji: '🌟', label: 'Previous partner', bg: '#fef3c7', border: '#fde68a', ink: '#92400e', title: 'confirmed deal or historic partnership' },
  { id: 'engaged', emoji: '📆', label: 'Engaged',          bg: '#dcecfa', border: '#a9c8eb', ink: '#1e3a5b', title: 'we met with this brand in the last 3 months' },
];

export const getSticker = (idOrEmoji) => STICKERS.find((s) => s.id === idOrEmoji || s.emoji === idOrEmoji);
